import { FC, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";

import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";

interface DeletePostModalProps {
  onDelete: () => void;
}

export const DeletePostModal: FC<DeletePostModalProps> = ({ onDelete }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleDelete = () => {
    onDelete();
    handleCloseModal();
  };

  return (
    <Box>
      <IconButton
        sx={{ marginTop: "10px", padding: "10px" }}
        onClick={handleOpenModal}
        color="primary"
        type="submit"
      >
        <DeleteForeverRoundedIcon
          sx={{ fontWeight: "bold", color: "black" }}
          fontSize="medium"
        />
        {/* <DeleteForeverTwoToneIcon fontSize="small" /> */}
      </IconButton>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Durch diese Aktion wird der Eintrag dauerhaft gelöscht
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDelete}
            color="error"
            size="small"
            variant="contained"
          >
            Ja, löschen
          </Button>
          <Button
            onClick={handleCloseModal}
            size="small"
            variant="contained"
            autoFocus
          >
            Abbrechen
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
